module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsSAAALEgHS3X78AAAAR0lEQVQ4y+XTwQ0AMAgCwNphHcpl6QQCqUk/5c89JAaANclew7wBqgrXACtLQJUp4JRbwC23QGbGeAUXoUd0EDmjQuKTX2A5O20Y5gpL5PsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/dataGrid/icon_left_kong.png
// module id = 2028
// module chunks = 50